module.exports = __webpack_public_path__ + "static/media/ic_phone.8854108b.svg";